// import React, { useState, useRef, useEffect } from "react";
// import { InputText } from "primereact/inputtext";
// import Checkbox from "@mui/material/Checkbox";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import ReusableTable from "../components/Table/ReusableTable";
// import Button from "../components/Button/Button";
// import { CirclePlus, SquarePen } from "lucide-react";
// import { post } from "../utils/api";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";

// const AddDistributorForm = ({ userId, distributorData, onBack }) => {
//   const [distributor_id, setDistributorId] = useState(0);
//   const [form, setForm] = useState({
//     distributor_name: "",
//     arn_code: "",
//     arn_expiry_date: null,
//     pan_number: "",
//     pin_code: "",
//     city: "",
//     is_arn_active: true,
//     spoc_name: "",
//     spoc_email1: "",
//     spoc_email2: "",
//     spoc_mobile1: "",
//     spoc_mobile2: "",
//     spoc_is_primary: false,
//   });
//   const [spocList, setSpocList] = useState([]);
//   const [editingSpocId, setEditingSpocId] = useState(null);
//   const [showCalendar, setShowCalendar] = useState(false);
//   const calendarRef = useRef(null);
//   const inputRef = useRef(null);
//   const [errors, setErrors] = useState({});
//   const [isSaveDisabled, setIsSaveDisabled] = useState(true);

//   const isEditMode = distributor_id > 0;

//   // Check if ARN is expired based on expiry date
//   const isArnExpired = () => {
//     if (!form.arn_expiry_date) return false;
//     const expiryDate = new Date(form.arn_expiry_date);
//     const today = new Date();
//     return expiryDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
//   };

//   // Check if at least one SPOC is marked as primary
//   const hasPrimarySpoc = () => {
//     return spocList.some(spoc => spoc.spoc_is_primary === "Yes");
//   };

//   // Update is_arn_active based on expiry date
//   useEffect(() => {
//     const expired = isArnExpired();
//     if (expired && form.is_arn_active) {
//       setForm(prev => ({ ...prev, is_arn_active: false }));
//     }
//   }, [form.arn_expiry_date]);

//   useEffect(() => {
//     if (distributorData && distributorData.id) {
//       setDistributorId(distributorData.id);
//       // Parse date using moment
//       const expiryDate = distributorData.arn_expiry_date
//         ? moment(distributorData.arn_expiry_date, "DD-MM-YYYY").toDate()
//         : null;
//       const expired =
//         expiryDate &&
//         expiryDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);

//       setForm({
//         distributor_name: distributorData.distributor_name || "",
//         arn_code: distributorData.arn_code || "",
//         arn_expiry_date: expiryDate,
//         pan_number: distributorData.pan_number || "",
//         pin_code: distributorData.pin_code || "",
//         city: distributorData.city || "",
//         is_arn_active: expired ? false : (distributorData.is_arn_active ?? true),
//         spoc_name: "",
//         spoc_email1: "",
//         spoc_email2: "",
//         spoc_mobile1: "",
//         spoc_mobile2: "",
//         spoc_is_primary: false,
//       });
//       fetchSpocsFromAPI(distributorData.id);
//     }
//   }, [distributorData]);

//   useEffect(() => {
//     const handler = (e) => {
//       if (
//         calendarRef.current &&
//         !calendarRef.current.contains(e.target) &&
//         inputRef.current &&
//         !inputRef.current.contains(e.target)
//       ) {
//         setShowCalendar(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   useEffect(() => {
//     setIsSaveDisabled(!isFormValid());
//   }, [form, distributor_id, spocList]);

//   const handleChange = (field, value) => {
//     if (field === "pan_number") {
//       value = value.toUpperCase();
//     }
//     setForm((prev) => ({ ...prev, [field]: value }));
//     setErrors((prev) => ({ ...prev, [field]: null }));
//   };

//   const validateFields = () => {
//     const errs = {};

//     // Required fields
//     const requiredFields = [
//       "distributor_name",
//       "pan_number",
//       "pin_code",
//       "city",
//     ];
//     requiredFields.forEach((field) => {
//       if (!form[field]) {
//         errs[field] = "Required";
//       }
//     });

//     // ARN expiry date is required only if ARN code is provided
//     if (form.arn_code && !form.arn_expiry_date) {
//       errs.arn_expiry_date = "Required when ARN code is provided";
//     }

//     // Required SPOC fields if new distributor
//     if (!distributor_id) {
//       if (!form.spoc_name) errs.spoc_name = "Required";
//       if (!form.spoc_email1) errs.spoc_email1 = "Required";
//       if (!form.spoc_mobile1) errs.spoc_mobile1 = "Required";
//     }

//     // PAN format
//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
//     if (form.pan_number && !panRegex.test(form.pan_number.toUpperCase())) {
//       errs.pan_number = "Invalid PAN format (e.g. ABCDE1234F)";
//     }

//     // PIN code: 6 digit number
//     const pinRegex = /^[0-9]{6}$/;
//     if (form.pin_code && !pinRegex.test(form.pin_code)) {
//       errs.pin_code = "Invalid pin code (6 digits)";
//     }

//     // Email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
//     if (form.spoc_email1 && !emailRegex.test(form.spoc_email1)) {
//       errs.spoc_email1 = "Invalid email format";
//     }
//     if (
//       form.spoc_email2 &&
//       form.spoc_email2.length > 0 &&
//       !emailRegex.test(form.spoc_email2)
//     ) {
//       errs.spoc_email2 = "Invalid email format";
//     }

//     if (
//       form.spoc_email1 &&
//       form.spoc_email2 &&
//       form.spoc_email1.toLowerCase() === form.spoc_email2.toLowerCase()
//     ) {
//       errs.spoc_email2 = "Email 2 must be different from Email 1";
//     }

//     // Mobile format
//     const mobileRegex = /^[6-9][0-9]{9}$/;
//     if (form.spoc_mobile1 && !mobileRegex.test(form.spoc_mobile1)) {
//       errs.spoc_mobile1 =
//         "Invalid mobile number (must start with 6-9 and be 10 digits)";
//     }
//     if (
//       form.spoc_mobile2 &&
//       form.spoc_mobile2.length > 0 &&
//       !mobileRegex.test(form.spoc_mobile2)
//     ) {
//       errs.spoc_mobile2 =
//         "Invalid mobile number (must start with 6-9 and be 10 digits)";
//     }

//     if (
//       form.spoc_mobile1 &&
//       form.spoc_mobile2 &&
//       form.spoc_mobile1 === form.spoc_mobile2
//     ) {
//       errs.spoc_mobile2 = "Mobile 2 must be different from Mobile 1";
//     }

//     // Check if at least one primary SPOC exists
//     if (!hasPrimarySpoc() && !form.spoc_is_primary) {
//       errs.spoc_is_primary = "At least one SPOC must be marked as primary";
//     }

//     setErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   const fetchSpocsFromAPI = async (id) => {
//     try {
//       const resp = await post("/distributor/fetchDistributorsSPOC", {
//         distributor_id: id,
//       });
//       if (resp.data.Success && Array.isArray(resp.data.Data)) {
//         const mapped = resp.data.Data.map((s) => ({
//           spoc_id: s.id,
//           spoc_name: s.spoc_name,
//           spoc_email1: s.email_1,
//           spoc_email2: s.email_2,
//           spoc_mobile1: s.mobile_1,
//           spoc_mobile2: s.mobile_2,
//           spoc_is_primary: s.is_primary ? "Yes" : "No",
//         }));
//         setSpocList(mapped);
//       } else {
//         setSpocList([]);
//         toast.warn("No SPOC records found.");
//       }
//     } catch {
//       toast.error("Failed to fetch SPOCs.");
//     }
//   };

//   const isFormValid = () => {
//     const {
//       distributor_name,
//       arn_code,
//       arn_expiry_date,
//       pan_number,
//       pin_code,
//       city,
//       spoc_name,
//       spoc_email1,
//       spoc_mobile1,
//     } = form;

//     // Required distributor fields
//     if (
//       !distributor_name ||
//       !pan_number ||
//       !pin_code ||
//       !city
//     ) {
//       return false;
//     }

//     // ARN expiry date is required only if ARN code is provided
//     if (arn_code && !arn_expiry_date) {
//       return false;
//     }

//     const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
//     if (!panRegex.test(pan_number)) return false;

//     const pinRegex = /^[0-9]{6}$/;
//     if (!pinRegex.test(pin_code)) return false;

//     // Check if at least one primary SPOC exists
//     if (!hasPrimarySpoc() && !form.spoc_is_primary) {
//       return false;
//     }

//     // For Add SPOC button, these validations should be done separately
//     if (spoc_name || spoc_email1 || spoc_mobile1) {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
//       const mobileRegex = /^[6-9][0-9]{9}$/;

//       if (!spoc_name || !spoc_email1 || !spoc_mobile1) return false;
//       if (!emailRegex.test(spoc_email1)) return false;
//       if (!mobileRegex.test(spoc_mobile1)) return false;
//     }

//     return true;
//   };

//   const handleAddSpoc = async () => {
//     // First check if required SPOC fields are filled
//     const requiredSpocFields = {
//       spoc_name: "SPOC Name",
//       spoc_email1: "Email 1",
//       spoc_mobile1: "Mobile 1",
//     };

//     const emptyFields = Object.entries(requiredSpocFields)
//       .filter(([field]) => !form[field]?.trim())
//       .map(([_, label]) => label);

//     if (emptyFields.length > 0) {
//       toast.error(`Please fill required SPOC fields: ${emptyFields.join(", ")}`);

//       // Set errors for empty fields
//       const newErrors = {};
//       Object.keys(requiredSpocFields).forEach((field) => {
//         if (!form[field]?.trim()) {
//           newErrors[field] = "Required";
//         }
//       });
//       setErrors((prev) => ({...prev, ...newErrors}));
//       return;
//     }

//     // Rest of your existing validation
//     if (!validateFields()) {
//       toast.error("Please correct errors.");
//       return;
//     }

//     // Check for duplicate email or mobile within the local spocList
//     const email = form.spoc_email1.trim().toLowerCase();
//     const mobile = form.spoc_mobile1.trim();

//     const hasDuplicateInList = spocList.some(
//       (spoc) =>
//         spoc.spoc_email1.trim().toLowerCase() === email ||
//         spoc.spoc_mobile1.trim() === mobile
//     );

//     if (hasDuplicateInList) {
//       toast.error("Duplicate SPOC email or mobile already exists in list.");
//       setErrors((prev) => ({
//         ...prev,
//         spoc_email1: "Duplicate email in list",
//         spoc_mobile1: "Duplicate mobile in list",
//       }));
//       return;
//     }

//     // Only check API if not local duplicate
//     if (!distributor_id) {
//       const hasDuplicateDistributor = await checkDuplicateDistributor();
//       if (hasDuplicateDistributor) return;

//       const hasDuplicateSpoc = await checkDuplicateSpoc();
//       if (hasDuplicateSpoc) return;
//     }

//     const expired = isArnExpired();

//     // Format the expiry date only if it exists
//     const formattedExpiryDate = form.arn_expiry_date 
//       ? form.arn_expiry_date.toISOString().split("T")[0] 
//       : null;

//     // Add SPOC logic here (your existing API call)
//     try {
//       const resp = await post("/distributor/addSPOCDistributor", {
//         user_Id: userId,
//         distributor_name: form.distributor_name.toUpperCase(),
//         arn_code: form.arn_code.toUpperCase(),
//         arn_expiry_date: formattedExpiryDate,
//         pan_number: form.pan_number.toUpperCase(),
//         city: form.city.toUpperCase(),
//         pincode: form.pin_code.toUpperCase(),
//         is_arn_active: form.is_arn_active,
//         is_active: !expired, // Set is_active based on ARN expiry
//         spoc_details: {
//           spoc_name: form.spoc_name,
//           email_1: form.spoc_email1.toUpperCase(),
//           email_2: form.spoc_email2 ? form.spoc_email2.toUpperCase() : null,
//           mobile_1: form.spoc_mobile1,
//           mobile_2: form.spoc_mobile2,
//           is_primary: form.spoc_is_primary,
//           is_active: true,
//         },
//       });

//       if (resp.data.Success) {
//         toast.success("SPOC created successfully");
//         const newId = distributor_id || resp.data.Data;
//         setDistributorId(newId);
//         await fetchSpocsFromAPI(newId);

//         setForm((prev) => ({
//           ...prev,
//           spoc_name: "",
//           spoc_email1: "",
//           spoc_email2: "",
//           spoc_mobile1: "",
//           spoc_mobile2: "",
//           spoc_is_primary: false,
//         }));
//       } else {
//         toast.error(resp.data.Message || "Add SPOC failed");
//       }
//     } catch {
//       toast.error("Error occurred while adding SPOC");
//     }
//   };

//   const handleUpdateSpoc = async () => {
//     if (!validateFields()) {
//       toast.error("Please correct errors.");
//       return;
//     }

//     // Check for duplicate in list (excluding the one being edited)
//     const email = form.spoc_email1.trim().toLowerCase();
//     const mobile = form.spoc_mobile1.trim();

//     const hasDuplicateInList = spocList.some(
//       (spoc) =>
//         spoc.spoc_id !== editingSpocId &&
//         (spoc.spoc_email1.trim().toLowerCase() === email ||
//           spoc.spoc_mobile1.trim() === mobile)
//     );

//     if (hasDuplicateInList) {
//       toast.error("Duplicate SPOC email or mobile already exists in list.");
//       setErrors((prev) => ({
//         ...prev,
//         spoc_email1: "Duplicate email in list",
//         spoc_mobile1: "Duplicate mobile in list",
//       }));
//       return;
//     }

//     const hasDuplicateSpoc = await checkDuplicateSpoc();
//     if (hasDuplicateSpoc) return;

//     try {
//       const resp = await post("/distributor/updateSPOC", {
//         user_Id: userId,
//         distributor_id,
//         spoc_details: {
//           spoc_id: editingSpocId,
//           spoc_name: form.spoc_name,
//           email_1: form.spoc_email1.toUpperCase(),
//           email_2: form.spoc_email2 ? form.spoc_email2.toUpperCase() : null,
//           mobile_1: form.spoc_mobile1,
//           mobile_2: form.spoc_mobile2,
//           is_primary: form.spoc_is_primary,
//         },
//       });
//       if (resp.data.Success) {
//         toast.success("SPOC updated successfully");
//         await fetchSpocsFromAPI(distributor_id);
//         setEditingSpocId(null);
//         setForm((prev) => ({
//           ...prev,
//           spoc_name: "",
//           spoc_email1: "",
//           spoc_email2: "",
//           spoc_mobile1: "",
//           spoc_mobile2: "",
//           spoc_is_primary: false,
//         }));
//       } else {
//         toast.error(resp.data.Message || "Update SPOC failed");
//       }
//     } catch {
//       toast.error("Error occurred while updating SPOC");
//     }
//   };

//   const checkDuplicateDistributor = async () => {
//     try {
//       const resp = await post("/distributor/checkDuplicate", {
//         arn_code: form.arn_code,
//         pan_number: form.pan_number,
//         distributor_id: distributor_id, // Pass current ID for edit mode
//       });

//       if (resp.data.duplicate) {
//         if (resp.data.duplicateField === "arn_code") {
//           setErrors((prev) => ({
//             ...prev,
//             arn_code: "ARN Code already exists",
//           }));
//           toast.error("ARN Code already exists");
//           return true;
//         }
//         if (resp.data.duplicateField === "pan_number") {
//           setErrors((prev) => ({
//             ...prev,
//             pan_number: "PAN Number already exists",
//           }));
//           toast.error("PAN Number already exists");
//           return true;
//         }
//       }
//       return false;
//     } catch (error) {
//       toast.error("Error checking for duplicates");
//       return true;
//     }
//   };

//   const checkDuplicateSpoc = async () => {
//     try {
//       const resp = await post("/distributor/checkDuplicateSpoc", {
//         email: form.spoc_email1,
//         mobile: form.spoc_mobile1,
//         distributor_id: distributor_id,
//         spoc_id: editingSpocId, // Pass current SPOC ID for edit mode
//       });

//       if (resp.data.duplicate) {
//         if (resp.data.duplicateField === "email") {
//           setErrors((prev) => ({
//             ...prev,
//             spoc_email1: "Email already exists",
//           }));
//           toast.error("SPOC Email already exists");
//           return true;
//         }
//         if (resp.data.duplicateField === "mobile") {
//           setErrors((prev) => ({
//             ...prev,
//             spoc_mobile1: "Mobile number already exists",
//           }));
//           toast.error("SPOC Mobile number already exists");
//           return true;
//         }
//       }
//       return false;
//     } catch (error) {
//       toast.error("Error checking for duplicate SPOC");
//       return true;
//     }
//   };

//   // Function to toggle ARN status - Only allow if expiry date is in future
//   const toggleArnStatus = async () => {
//     if (isArnExpired()) {
//       toast.warn("Cannot activate ARN with expired date. Please update expiry date first.");
//       return;
//     }

//     if (!distributor_id) {
//       toast.warn("Please save the distributor first before toggling status.");
//       return;
//     }

//     try {
//       const endpoint = form.is_arn_active 
//         ? "/distributor/inactivateDistributor" 
//         : "/distributor/activateDistributor";

//       const response = await post(endpoint, {
//         distributor_id,
//         user_Id: userId,
//       });

//       if (response.data?.Success) {
//         setForm(prev => ({ ...prev, is_arn_active: !form.is_arn_active }));
//         toast.success(`Distributor ${form.is_arn_active ? 'inactivated' : 'activated'} successfully`);
//       } else {
//         toast.error(response.data?.Message || `Failed to ${form.is_arn_active ? 'inactivate' : 'activate'} distributor`);
//       }
//     } catch (error) {
//       toast.error("An error occurred while updating distributor status");
//     }
//   };

//   // Function to save distributor details
//   const handleSaveDistributor = async () => {
//     // Check if at least one SPOC is marked as primary
//     if (!hasPrimarySpoc()) {
//       toast.error("At least one SPOC must be marked as primary before saving.");
//       setErrors(prev => ({ ...prev, spoc_is_primary: "At least one SPOC must be marked as primary" }));
//       return;
//     }

//     if (!validateFields()) {
//       toast.error("Please fill all required fields correctly.");
//       return;
//     }

//     const expired = isArnExpired();

//     try {
//       // Format the expiry date only if it exists
//       const formattedExpiryDate = form.arn_expiry_date 
//         ? form.arn_expiry_date.toISOString().split("T")[0] 
//         : null;

//       const resp = await post("/distributor/updateDistributor", {
//         distributor_id: distributor_id,
//         user_Id: userId,
//         distributor_name: form.distributor_name,
//         arn_code: form.arn_code,
//         arn_expiry_date: formattedExpiryDate,
//         pan_number: form.pan_number,
//         city: form.city,
//         pincode: form.pin_code,
//         is_arn_active: expired ? false : form.is_arn_active, // Force inactive if expired
//         is_active: !expired, // Set is_active based on ARN expiry
//       });

//       if (resp.data.Success) {
//         toast.success("Distributor updated successfully");
//         setEditingSpocId(null);
//         onBack(); // Navigate back after successful update
//       } else {
//         toast.error(resp.data.Message || "Update distributor failed");
//       }
//     } catch (error) {
//       toast.error("Error occurred while updating distributor");
//     }
//   };

//   const spocColumns = [
//     {
//       Header: "Edit",
//       accessor: "edit",
//       Cell: ({ row }) => (
//         <Button
//           variant="ghost"
//           onClick={() => {
//             setEditingSpocId(row.original.spoc_id);
//             setForm((prev) => ({
//               ...prev,
//               spoc_name: row.original.spoc_name,
//               spoc_email1: row.original.spoc_email1,
//               spoc_email2: row.original.spoc_email2,
//               spoc_mobile1: row.original.spoc_mobile1,
//               spoc_mobile2: row.original.spoc_mobile2,
//               spoc_is_primary: row.original.spoc_is_primary === "Yes",
//             }));
//           }}
//         >
//           <SquarePen size={18} />
//         </Button>
//       ),
//       disableSortBy: true,
//       size: 80,
//     },
//     { Header: "SPOC Name", accessor: "spoc_name", size: 100 },
//     { Header: "Email 1", accessor: "spoc_email1", size: 200 },
//     { Header: "Email 2", accessor: "spoc_email2", size: 200 },
//     { Header: "Mobile 1", accessor: "spoc_mobile1", size: 100 },
//     { Header: "Mobile 2", accessor: "spoc_mobile2", size: 100 },
//     { 
//       Header: "Is Primary", 
//       accessor: "spoc_is_primary", 
//       size: 80,
//       Cell: ({ value }) => (
//         <span className={value === "Yes" ? "text-green-600 font-semibold" : "text-gray-500"}>
//           {value}
//         </span>
//       )
//     },
//   ];

//   const renderInput = (
//     field,
//     label,
//     placeholder,
//     type = "text",
//     cols = "col-span-1"
//   ) => (
//     <div className={cols}>
//       <label className="block font-medium mb-1">
//         {label}
//         {(field === "distributor_name" ||
//           field === "pan_number" ||
//           field === "pin_code" ||
//           field === "city" ||
//           (!distributor_id &&
//             (field === "spoc_name" ||
//               field === "spoc_email1" ||
//               field === "spoc_mobile1"))) && (
//           <span className="text-red-600"> *</span>
//         )}
//       </label>
//       <InputText
//         type={type}
//         value={form[field] || ""}
//         onChange={(e) => {
//           let value = e.target.value;

//           // PAN: Uppercase
//           if (field === "pan_number") {
//             value = value.toUpperCase();
//           }

//           // Mobile: Allow digits only, max 10
//           if (field === "spoc_mobile1" || field === "spoc_mobile2") {
//             value = value.replace(/\D/g, ""); // remove non-digits
//             value = value.slice(0, 10); // max 10 digits
//           }

//           // PIN: Allow digits only, max 6
//           if (field === "pin_code") {
//             value = value.replace(/\D/g, "");
//             value = value.slice(0, 6);
//           }

//           // Prevent special characters in some fields
//           const fieldsNoSpecialChars = [
//             "distributor_name",
//             "city",
//             "spoc_name",
//             "arn_code",
//           ];
//           if (fieldsNoSpecialChars.includes(field)) {
//             value = removeSpecialCharacters(value);
//           }

//           handleChange(field, value);
//         }}
//         placeholder={placeholder}
//         className={`w-full px-2 ${
//           errors[field] ? "border border-red-500" : ""
//         }`}
//       />
//       {errors[field] && (
//         <p className="text-red-500 text-sm mt-1">{errors[field]}</p>
//       )}
//     </div>
//   );

//   // Helper to remove special characters (allows letters, digits, spaces)
//   const removeSpecialCharacters = (value) => value.replace(/[^\w\s]/gi, "");

//   return (
//     <>
//       <div className="max-w-screen-xl mx-auto p-4 bg-white rounded shadow space-y-6">
//         <h2 className="text-md font-semibold underline text-left">
//           Distributor Details
//         </h2>
//         {/* form inputs for distributor */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//           {renderInput("distributor_name", "Distributor Name", "Enter name")}
//           {renderInput("arn_code", "ARN Code", "Enter ARN code")}
//           <div className="relative">
//             <label className="block font-medium mb-1">
//               ARN Expiry Date 
//               {form.arn_code && <span className="text-red-600"> *</span>}
//             </label>
//             <InputText
//               ref={inputRef}
//               value={
//                 form.arn_expiry_date
//                   ? form.arn_expiry_date.toLocaleDateString()
//                   : ""
//               }
//               onFocus={() => setShowCalendar(true)}
//               readOnly
//               placeholder="Select date"
//               className={`w-full cursor-pointer px-2 ${
//                 errors.arn_expiry_date ? "border border-red-500" : ""
//               }`}
//             />
//             {showCalendar && (
//               <div
//                 ref={calendarRef}
//                 className="absolute z-10 bg-white shadow-md mt-2 transform scale-75 origin-top-left"
//               >
//                 <Calendar
//                   value={form.arn_expiry_date || new Date()}
//                   minDate={new Date()} // ⛔ disallow past dates
//                   onChange={(date) => {
//                     handleChange("arn_expiry_date", date);
//                     setShowCalendar(false);

//                     const expired = new Date(date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);

//                     if (expired) {
//                       toast.warn(
//                         "ARN Expiry is in the past. Distributor will be marked inactive."
//                       );
//                       setForm(prev => ({ ...prev, is_arn_active: false }));
//                     } else {
//                       // Only allow activating if date is in future
//                       setForm(prev => ({ ...prev, is_arn_active: true }));
//                     }
//                   }}
//                 />
//               </div>
//             )}
//             {errors.arn_expiry_date && (
//               <p className="text-red-500 text-sm mt-1">
//                 {errors.arn_expiry_date}
//               </p>
//             )}
//           </div>
//           {renderInput("pan_number", "PAN Number", "Enter PAN")}
//           {renderInput("pin_code", "Pin Code", "Enter pin")}
//           {renderInput("city", "City", "Enter city")}
//           <div className="flex justify-center items-center mt-6">
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={form.is_arn_active}
//                   onChange={toggleArnStatus}
//                   disabled={isArnExpired()} // Disable if expired
//                 />
//               }
//               label={
//                 <span>
//                   Is ARN Active
//                   {isArnExpired() && (
//                     <span className="text-red-600 ml-2">(Expired)</span>
//                   )}
//                 </span>
//               }
//             />
//           </div>
//         </div>
//       </div>

//       <div className="max-w-screen-xl mx-auto p-4 bg-white rounded shadow space-y-6 mt-6">
//         <h2 className="text-md font-semibold underline text-left">
//           SPOC Details
//         </h2>

//         {/* Primary SPOC Validation Message */}
//         {!hasPrimarySpoc() && (
//           <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
//             <p className="text-yellow-800 text-sm">
//               ⚠️ At least one SPOC must be marked as primary before saving.
//             </p>
//           </div>
//         )}

//         <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
//           {renderInput(
//             "spoc_name",
//             "SPOC Name",
//             "Enter SPOC",
//             "text",
//             "col-span-2"
//           )}
//           {renderInput(
//             "spoc_email1",
//             "Email 1",
//             "Enter email",
//             "email",
//             "col-span-2"
//           )}
//           {renderInput(
//             "spoc_email2",
//             "Email 2",
//             "Enter email",
//             "email",
//             "col-span-2"
//           )}
//           {renderInput(
//             "spoc_mobile1",
//             "Mobile 1",
//             "Enter mobile",
//             "tel",
//             "col-span-2"
//           )}
//           {renderInput(
//             "spoc_mobile2",
//             "Mobile 2",
//             "Enter mobile",
//             "tel",
//             "col-span-2"
//           )}
//           <div className="col-span-2 flex items-center mt-6">
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={form.spoc_is_primary}
//                   onChange={(e) =>
//                     handleChange("spoc_is_primary", e.target.checked)
//                   }
//                 />
//               }
//               label={
//                 <span>
//                   Is Primary <span className="text-red-600">*</span>
//                 </span>
//               }
//             />
//             {errors.spoc_is_primary && (
//               <p className="text-red-500 text-sm ml-2">
//                 {errors.spoc_is_primary}
//               </p>
//             )}
//           </div>
//         </div>

//         <Button
//           variant="outline"
//           size="sm"
//           className="flex gap-1 items-center justify-center py-1 px-2"
//           onClick={editingSpocId ? handleUpdateSpoc : handleAddSpoc}
//           disabled={!form.spoc_name?.trim() || !form.spoc_email1?.trim() || !form.spoc_mobile1?.trim()}
//         >
//           <CirclePlus /> {editingSpocId ? "Update SPOC" : "Add SPOC"}
//         </Button>

//         <div className="mt-6 overflow-x-auto">
//           <ReusableTable columns={spocColumns} data={spocList} />
//         </div>

//         <div className="mt-2 gap-2 flex justify-center items-center">
//           <Button
//             variant="default"
//             disabled={isSaveDisabled}
//             onClick={handleSaveDistributor}
//           >
//             Save
//           </Button>

//           <Button
//             variant="outline"
//             onClick={() => {
//               setEditingSpocId(null);
//               onBack();
//             }}
//           >
//             Cancel
//           </Button>
//         </div>
//       </div>

//       <ToastContainer position="top-right" autoClose={3000} />
//     </>
//   );
// };

// export default AddDistributorForm;


import React, { useState, useRef, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ReusableTable from "../components/Table/ReusableTable";
import Calendar from "react-calendar";
import { CirclePlus, SquarePen, Trash2, Check, X, ArrowLeft, Save, Plus } from "lucide-react";
import { toast } from "react-toastify";
import { post } from "../utils/api";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-calendar/dist/Calendar.css";
import moment from "moment";

const AddDistributorForm = ({
  userId,
  distributorData,
  onBack
}) => {
  // State for distributor ID
  const [distributor_id, setDistributorId] = useState(0);

  // Main form state
  const [form, setForm] = useState({
    distributor_name: "",
    arn_code: "",
    arn_expiry_date: null,
    pan_number: "",
    pin_code: "",
    city: "",
    address: "",
    authorized_signatory: "",
    is_arn_active: true,

    // SPOC
    spoc_name: "",
    spoc_email1: "",
    spoc_email2: "",
    spoc_mobile1: "",
    spoc_mobile2: "",
    spoc_is_primary: false,

    // Bank
    bank_name: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
    bank_branch: "",
  });

  // Additional states
  const [spocList, setSpocList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [editingSpocId, setEditingSpocId] = useState(null);
  const [editingBankId, setEditingBankId] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Fund Details States
  const [fundType, setFundType] = useState("");
  const [fundNames, setFundNames] = useState([]);
  const [selectedFundName, setSelectedFundName] = useState("");
  const [classCodes, setClassCodes] = useState([]);
  const [selectedClassCode, setSelectedClassCode] = useState("");

  // Fund Tables Data
  const [aifCatIIData, setAifCatIIData] = useState([
    {
      fund_name: "",
      class: "",
      size: "",
      management_fee: "",
      placement_fee: "",
      upfront_fee: "",
      trail_fee: "",
      total_fee: "",
    },
  ]);

  const [aifCatIIIData, setAifCatIIIData] = useState([
    { fund_name: "", class: "", management_fee: "", performance_fee: "" },
  ]);

  const [pmsData, setPmsData] = useState([
    {
      fund_name: "",
      class: "",
      management_fee: "",
      distributor_sharing_fee: "",
    },
  ]);

  // Saved fund data
  const [savedFund, setSavedFund] = useState([]);
  const [fundTableType, setFundTableType] = useState("");

  const inputRef = useRef();
  const calendarRef = useRef();

  const isEditMode = distributor_id > 0;

  // Check if ARN is expired
  const isArnExpired = () => {
    if (!form.arn_expiry_date) return false;
    const expiryDate = new Date(form.arn_expiry_date);
    const today = new Date();
    return expiryDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
  };

  // Check if at least one SPOC is marked as primary
  const hasPrimarySpoc = () => {
    return spocList.some(spoc => spoc.spoc_is_primary === "Yes");
  };

  // Update is_arn_active based on expiry date
  useEffect(() => {
    const expired = isArnExpired();
    if (expired && form.is_arn_active) {
      setForm(prev => ({ ...prev, is_arn_active: false }));
    }
  }, [form.arn_expiry_date]);

  // Initialize form with distributor data if in edit mode
  useEffect(() => {
    console.log("🔄 AddDistributorForm useEffect triggered");
    console.log("📦 distributorData received:", distributorData);

    if (distributorData && distributorData.id) {
      console.log("✅ Initializing form with distributor ID:", distributorData.id);

      // Set distributor ID
      setDistributorId(distributorData.id);

      // Initialize basic form fields
      const newForm = {
        distributor_name: distributorData.distributor_name || "",
        arn_code: distributorData.arn_code || "",
        arn_expiry_date: distributorData.arn_expiry_date
          ? moment(distributorData.arn_expiry_date).isValid()
            ? new Date(distributorData.arn_expiry_date)
            : null
          : null,
        pan_number: distributorData.pan_number || "",
        pin_code: distributorData.pincode || "",
        city: distributorData.city || "",
        address: distributorData.address || "",
        authorized_signatory: distributorData.authorized_signatory || "",
        is_arn_active: distributorData.is_arn_active ?? true,

        // Reset SPOC form fields
        spoc_name: "",
        spoc_email1: "",
        spoc_email2: "",
        spoc_mobile1: "",
        spoc_mobile2: "",
        spoc_is_primary: false,

        // Reset Bank form fields
        bank_name: "",
        account_holder_name: "",
        account_number: "",
        ifsc_code: "",
        bank_branch: "",
      };

      console.log("📝 Setting form data:", newForm);
      setForm(newForm);

      // Initialize SPOC list
      if (Array.isArray(distributorData.spoc_details) && distributorData.spoc_details.length > 0) {
        const spocs = distributorData.spoc_details.map(spoc => ({
          spoc_id: spoc.id,
          spoc_name: spoc.spoc_name || "",
          spoc_email1: spoc.email_1 || "",
          spoc_email2: spoc.email_2 || "",
          spoc_mobile1: spoc.mobile_1 || "",
          spoc_mobile2: spoc.mobile_2 || "",
          spoc_is_primary: spoc.is_primary ? "Yes" : "No",
        }));
        console.log("👥 Setting SPOCs:", spocs);
        setSpocList(spocs);
      } else {
        console.log("❌ No SPOCs found in data");
        setSpocList([]);
      }

      // Initialize Bank list
      if (Array.isArray(distributorData.bank_details) && distributorData.bank_details.length > 0) {
        console.log("🏦 Setting banks:", distributorData.bank_details);
        setBankList(distributorData.bank_details);
      } else {
        console.log("❌ No banks found in data");
        setBankList([]);
      }

      // Initialize Fund data
      if (Array.isArray(distributorData.product_details) && distributorData.product_details.length > 0) {
        const funds = distributorData.product_details.map(product => ({
          fund_name: product.fund_name || "",
          class: product.class_code || "",
          size: product.size || "",
          management_fee: product.management_fee_sharing_per || "",
          placement_fee: product.placement_fee_per || "",
          upfront_fee: product.upfront_fee_per || "",
          trail_fee: product.trail_fee_per || "",
          total_fee: product.total_fee_per || "",
          performance_fee: product.performance_fee_sharing_per || "",
          distributor_sharing_fee: product.performance_fee_sharing_per || ""
        }));
        console.log("💰 Setting funds:", funds);
        setSavedFund(funds);
      } else {
        console.log("❌ No funds found in data");
        setSavedFund([]);
      }
    } else {
      console.log("❌ No distributorData or ID found");
      // Reset form for new distributor
      setDistributorId(0);
      setForm({
        distributor_name: "",
        arn_code: "",
        arn_expiry_date: null,
        pan_number: "",
        pin_code: "",
        city: "",
        address: "",
        authorized_signatory: "",
        is_arn_active: true,
        spoc_name: "",
        spoc_email1: "",
        spoc_email2: "",
        spoc_mobile1: "",
        spoc_mobile2: "",
        spoc_is_primary: false,
        bank_name: "",
        account_holder_name: "",
        account_number: "",
        ifsc_code: "",
        bank_branch: "",
      });
      setSpocList([]);
      setBankList([]);
      setSavedFund([]);
    }
  }, [distributorData]);

  // Close calendar when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(e.target) &&
        inputRef.current &&
        !inputRef.current.contains(e.target)
      ) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Fetch fund names when fund type changes
  useEffect(() => {
    if (fundType) {
      fetchFundNames(fundType);
    } else {
      setFundNames([]);
      setSelectedFundName("");
    }
  }, [fundType]);

  // Fetch class codes when fund name changes
  useEffect(() => {
    if (selectedFundName) {
      fetchClassCodes(selectedFundName);
    } else {
      setClassCodes([]);
      setSelectedClassCode("");
    }
  }, [selectedFundName]);

  const handleChange = (field, value) => {
    // Auto-uppercase for specific fields
    if (field === "pan_number" || field === "arn_code") {
      value = value.toUpperCase();
    }

    if (field === "city") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }

    if (field === "spoc_name") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    }

    // Mobile number validation - digits only, max 10
    if (field === "spoc_mobile1" || field === "spoc_mobile2") {
      value = value.replace(/\D/g, "");
      value = value.slice(0, 10);
    }

    // PIN code validation - digits only, max 6
    if (field === "pin_code") {
      value = value.replace(/\D/g, "");
      value = value.slice(0, 6);
    }

    // Prevent special characters in name fields
    const fieldsNoSpecialChars = [
      "distributor_name",
      "city",
      "address",
      "spoc_name",
      "bank_name",
      "account_holder_name",
      "bank_branch",
      "authorized_signatory",
    ];
    if (fieldsNoSpecialChars.includes(field)) {
      value = value.replace(/[^\w\s]/gi, "");
    }

    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: null }));
  };

  // Validation functions
  const validateFields = () => {
    const errs = {};

    // Required distributor fields
    const requiredFields = [
      "distributor_name",
      "pan_number",
      "pin_code",
      "city",
      "address",
    ];
    requiredFields.forEach((field) => {
      if (!form[field]) {
        errs[field] = "Required";
      }
    });

    // ARN expiry date is required only if ARN code is provided
    if (form.arn_code && !form.arn_expiry_date) {
      errs.arn_expiry_date = "Required when APRN code is provided";
    }

    // PAN format
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (form.pan_number && !panRegex.test(form.pan_number.toUpperCase())) {
      errs.pan_number = "Invalid PAN format (e.g. ABCDE1234F)";
    }

    // PIN code: 6 digit number
    const pinRegex = /^[0-9]{6}$/;
    if (form.pin_code && !pinRegex.test(form.pin_code)) {
      errs.pin_code = "Invalid pin code (6 digits)";
    }

    // Email validation for SPOC
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (form.spoc_email1 && !emailRegex.test(form.spoc_email1)) {
      errs.spoc_email1 = "Invalid email format";
    }
    if (form.spoc_email2 && form.spoc_email2.length > 0 && !emailRegex.test(form.spoc_email2)) {
      errs.spoc_email2 = "Invalid email format";
    }

    // Mobile validation for SPOC
    const mobileRegex = /^[6-9][0-9]{9}$/;
    if (form.spoc_mobile1 && !mobileRegex.test(form.spoc_mobile1)) {
      errs.spoc_mobile1 = "Invalid mobile number";
    }
    if (form.spoc_mobile2 && form.spoc_mobile2.length > 0 && !mobileRegex.test(form.spoc_mobile2)) {
      errs.spoc_mobile2 = "Invalid mobile number";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  // SIMPLIFIED: Check if form can be submitted
  const canSubmitForm = () => {
    // For edit mode, ALWAYS return true - button will never be disabled
    if (isEditMode) {
      return true;
    }

    // For new mode, do basic validation
    const basicFormValid = isFormValid();
    const hasSpocs = spocList.length > 0;
    const hasBanks = bankList.length > 0;
    const hasPrimarySpocCheck = hasPrimarySpoc();

    return basicFormValid && hasSpocs && hasBanks && hasPrimarySpocCheck;
  };

  // Basic form validation (only used for new distributors)
  const isFormValid = () => {
    const {
      distributor_name,
      arn_code,
      arn_expiry_date,
      pan_number,
      pin_code,
      city,
      address,
    } = form;

    // Required distributor fields
    const requiredFields = [
      "distributor_name",
      "pan_number",
      "pin_code",
      "city",
      "address",
    ];

    for (const field of requiredFields) {
      if (!form[field]?.toString().trim()) {
        return false;
      }
    }

    // ARN expiry date is required only if ARN code is provided
    if (arn_code?.trim() && !arn_expiry_date) {
      return false;
    }

    return true;
  };

  // API Functions for SPOC and Bank
  const fetchSpocsFromAPI = async (id) => {
    try {
      const resp = await post("/distributor/fetchDistributorsSPOC", {
        distributor_id: id,
      });
      if (resp.data.Success && Array.isArray(resp.data.Data)) {
        const mapped = resp.data.Data.map((s) => ({
          spoc_id: s.id,
          spoc_name: s.spoc_name,
          spoc_email1: s.email_1,
          spoc_email2: s.email_2,
          spoc_mobile1: s.mobile_1,
          spoc_mobile2: s.mobile_2,
          spoc_is_primary: s.is_primary ? "Yes" : "No",
        }));
        setSpocList(mapped);
      } else {
        setSpocList([]);
      }
    } catch {
      toast.error("Failed to fetch SPOCs.");
    }
  };

  const fetchBankDetails = async (id) => {
    try {
      const resp = await post("/distributor/fetchDistributorBankDetails", {
        distributor_id: id,
      });
      if (resp.data.Success && Array.isArray(resp.data.Data)) {
        setBankList(resp.data.Data);
      } else {
        setBankList([]);
      }
    } catch {
      toast.error("Failed to fetch bank details.");
    }
  };

  // Fund API Functions
  const fetchFundNames = async (fundType) => {
    if (!fundType) {
      setFundNames([]);
      setSelectedFundName("");
      return;
    }

    const payload = {
      distributor_id: "0",
      product_type: fundType,
    };

    try {
      const res = await post("/onboarding/getFundNamesForDistributor", payload);
      const data = res?.data?.Data || [];

      if (Array.isArray(data) && data.length > 0) {
        const mappedFunds = data.map((f, idx) => ({
          fund_id: String(f.fund_id || idx + 1),
          fund_name: f.fund_name || "Unnamed Fund",
        }));

        setFundNames(mappedFunds);
      } else {
        setFundNames([]);
        toast.warn("No funds found for this product type.");
      }
    } catch (err) {
      console.error("fetchFundNames error:", err);
      toast.error("Failed to fetch fund names. Please try again.");
      setFundNames([]);
    }
  };

  const fetchClassCodes = async (fundName) => {
    if (!fundName) {
      setClassCodes([]);
      setSelectedClassCode("");
      setFundTableType("");
      return;
    }

    const payload = {
      fund_name: fundName,
    };

    try {
      const res = await post("/onboarding/fetchClassCodeByFundName", payload);
      const data = res?.data?.Data || [];

      console.log("📊 Class codes response:", data);

      if (Array.isArray(data) && data.length > 0) {
        const mapped = data.map((c) => ({
          class_code: c.class_code || "",
          class_name: c.class_name || "",
          product_type_id: c.product_type_id || null,
        }));
        setClassCodes(mapped);

        const productTypeId = mapped[0]?.product_type_id;

        if (productTypeId === 1) {
          setFundTableType("aifII");
        } else if (productTypeId === 2) {
          setFundTableType("aifIII");
        } else {
          setFundTableType("pms");
        }
      } else {
        setClassCodes([]);
        setFundTableType("");
        toast.warn("No class codes found for this fund.");
      }
    } catch (err) {
      console.error("fetchClassCodes error:", err);
      toast.error("Failed to fetch class codes. Please try again.");
      setClassCodes([]);
      setFundTableType("");
    }
  };

  // SPOC Management
  const handleAddSpoc = async () => {
    // Validate required SPOC fields
    const requiredSpocFields = {
      spoc_name: "SPOC Name",
      spoc_email1: "Email 1",
      spoc_mobile1: "Mobile 1",
    };

    const emptyFields = Object.entries(requiredSpocFields)
      .filter(([field]) => !form[field]?.trim())
      .map(([_, label]) => label);

    if (emptyFields.length > 0) {
      toast.error(`Please fill required SPOC fields: ${emptyFields.join(", ")}`);
      const newErrors = {};
      Object.keys(requiredSpocFields).forEach((field) => {
        if (!form[field]?.trim()) {
          newErrors[field] = "Required";
        }
      });
      setErrors((prev) => ({ ...prev, ...newErrors }));
      return;
    }

    // Email and mobile validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const mobileRegex = /^[6-9][0-9]{9}$/;

    if (!emailRegex.test(form.spoc_email1)) {
      setErrors(prev => ({ ...prev, spoc_email1: "Invalid email format" }));
      toast.error("Invalid email format");
      return;
    }

    if (!mobileRegex.test(form.spoc_mobile1)) {
      setErrors(prev => ({ ...prev, spoc_mobile1: "Invalid mobile number" }));
      toast.error("Invalid mobile number");
      return;
    }

    // Check for duplicates in local list
    const email = form.spoc_email1.trim().toLowerCase();
    const mobile = form.spoc_mobile1.trim();

    const hasDuplicateInList = spocList.some(
      (spoc) =>
        spoc.spoc_email1.trim().toLowerCase() === email ||
        spoc.spoc_mobile1.trim() === mobile
    );

    if (hasDuplicateInList) {
      toast.error("Duplicate SPOC email or mobile already exists in list.");
      setErrors((prev) => ({
        ...prev,
        spoc_email1: "Duplicate email in list",
        spoc_mobile1: "Duplicate mobile in list",
      }));
      return;
    }

    const expired = isArnExpired();
    const formattedExpiryDate = form.arn_expiry_date
      ? form.arn_expiry_date.toISOString().split("T")[0]
      : null;

    try {
      const resp = await post("/distributor/addSPOCDistributor", {
        user_Id: userId,
        distributor_name: form.distributor_name.toUpperCase(),
        arn_code: form.arn_code.toUpperCase(),
        arn_expiry_date: formattedExpiryDate,
        pan_number: form.pan_number.toUpperCase(),
        city: form.city.toUpperCase(),
        address: form.address.toUpperCase(),
        pincode: form.pin_code.toUpperCase(),
        is_arn_active: form.is_arn_active,
        is_active: !expired,
        spoc_details: {
          spoc_name: form.spoc_name,
          email_1: form.spoc_email1.toUpperCase(),
          email_2: form.spoc_email2 ? form.spoc_email2.toUpperCase() : null,
          mobile_1: form.spoc_mobile1,
          mobile_2: form.spoc_mobile2,
          is_primary: form.spoc_is_primary,
          is_active: true,
        },
      });

      if (resp.data.Success) {
        toast.success("SPOC created successfully");
        const newId = distributor_id || resp.data.Data;
        setDistributorId(newId);
        await fetchSpocsFromAPI(newId);

        // Reset SPOC form
        setForm((prev) => ({
          ...prev,
          spoc_name: "",
          spoc_email1: "",
          spoc_email2: "",
          spoc_mobile1: "",
          spoc_mobile2: "",
          spoc_is_primary: false,
        }));
        setEditingSpocId(null);
      } else {
        toast.error(resp.data.Message || "Add SPOC failed");
      }
    } catch {
      toast.error("Error occurred while adding SPOC");
    }
  };

  const handleUpdateSpoc = async () => {
    if (!validateFields()) {
      toast.error("Please correct errors.");
      return;
    }

    // Check for duplicate in list (excluding the one being edited)
    const email = form.spoc_email1.trim().toLowerCase();
    const mobile = form.spoc_mobile1.trim();

    const hasDuplicateInList = spocList.some(
      (spoc) =>
        spoc.spoc_id !== editingSpocId &&
        (spoc.spoc_email1.trim().toLowerCase() === email ||
          spoc.spoc_mobile1.trim() === mobile)
    );

    if (hasDuplicateInList) {
      toast.error("Duplicate SPOC email or mobile already exists in list.");
      setErrors((prev) => ({
        ...prev,
        spoc_email1: "Duplicate email in list",
        spoc_mobile1: "Duplicate mobile in list",
      }));
      return;
    }

    try {
      const resp = await post("/distributor/updateSPOC", {
        user_Id: userId,
        distributor_id,
        spoc_details: {
          spoc_id: editingSpocId,
          spoc_name: form.spoc_name,
          email_1: form.spoc_email1.toUpperCase(),
          email_2: form.spoc_email2 ? form.spoc_email2.toUpperCase() : null,
          mobile_1: form.spoc_mobile1,
          mobile_2: form.spoc_mobile2,
          is_primary: form.spoc_is_primary,
        },
      });
      if (resp.data.Success) {
        toast.success("SPOC updated successfully");
        await fetchSpocsFromAPI(distributor_id);
        setEditingSpocId(null);
        setForm((prev) => ({
          ...prev,
          spoc_name: "",
          spoc_email1: "",
          spoc_email2: "",
          spoc_mobile1: "",
          spoc_mobile2: "",
          spoc_is_primary: false,
        }));
      } else {
        toast.error(resp.data.Message || "Update SPOC failed");
      }
    } catch {
      toast.error("Error occurred while updating SPOC");
    }
  };

  const handleDeleteSPOC = async (spocId) => {
    if (!window.confirm("Are you sure you want to delete this SPOC?")) return;
    try {
      const resp = await post("/distributor/deleteSPOC", {
        spoc_id: spocId,
        user_Id: userId,
      });
      if (resp.data.Success) {
        toast.success("SPOC deleted successfully");
        await fetchSpocsFromAPI(distributor_id);
      } else {
        toast.error(resp.data.Message || "Delete failed");
      }
    } catch {
      toast.error("Error deleting SPOC");
    }
  };

  // Bank Management
  const handleAddBank = async () => {
    // Validate required bank fields
    const requiredBankFields = {
      bank_name: "Bank Name",
      account_holder_name: "Account Holder Name",
      account_number: "Account Number",
      ifsc_code: "IFSC Code",
    };

    const emptyFields = Object.entries(requiredBankFields)
      .filter(([field]) => !form[field]?.trim())
      .map(([_, label]) => label);

    if (emptyFields.length > 0) {
      toast.error(`Please fill required bank fields: ${emptyFields.join(", ")}`);
      const newErrors = {};
      Object.keys(requiredBankFields).forEach((field) => {
        if (!form[field]?.trim()) {
          newErrors[field] = "Required";
        }
      });
      setErrors((prev) => ({ ...prev, ...newErrors }));
      return;
    }

    // Check for duplicates in local list
    const accountNumber = form.account_number.trim();
    const hasDuplicateInList = bankList.some(
      (bank) => bank.account_number.trim() === accountNumber
    );

    if (hasDuplicateInList) {
      toast.error("Duplicate account number already exists in list.");
      setErrors((prev) => ({
        ...prev,
        account_number: "Duplicate account number in list",
      }));
      return;
    }

    const expired = isArnExpired();
    const formattedExpiryDate = form.arn_expiry_date
      ? form.arn_expiry_date.toISOString().split("T")[0]
      : null;

    try {
      const resp = await post("/distributor/addBankDistributor", {
        user_Id: userId,
        distributor_name: form.distributor_name.toUpperCase(),
        arn_code: form.arn_code.toUpperCase(),
        arn_expiry_date: formattedExpiryDate,
        pan_number: form.pan_number.toUpperCase(),
        city: form.city.toUpperCase(),
        address: form.address.toUpperCase(),
        pincode: form.pin_code.toUpperCase(),
        is_arn_active: form.is_arn_active,
        is_active: !expired,
        bank_details: {
          bank_name: form.bank_name,
          account_holder_name: form.account_holder_name,
          account_number: form.account_number,
          ifsc_code: form.ifsc_code,
          bank_branch: form.bank_branch,
          is_active: true,
        },
      });

      if (resp.data.Success) {
        toast.success("Bank details added successfully");
        const newId = distributor_id || resp.data.Data;
        setDistributorId(newId);
        await fetchBankDetails(newId);

        // Reset bank form
        setForm((prev) => ({
          ...prev,
          bank_name: "",
          account_holder_name: "",
          account_number: "",
          ifsc_code: "",
          bank_branch: "",
        }));
        setEditingBankId(null);
      } else {
        toast.error(resp.data.Message || "Add Bank failed");
      }
    } catch {
      toast.error("Error occurred while adding Bank Details");
    }
  };

  const handleUpdateBank = async () => {
    // Check for duplicate in list (excluding the one being edited)
    const accountNumber = form.account_number.trim();
    const hasDuplicateInList = bankList.some(
      (bank) =>
        bank.id !== editingBankId &&
        bank.account_number.trim() === accountNumber
    );

    if (hasDuplicateInList) {
      toast.error("Duplicate account number already exists in list.");
      setErrors((prev) => ({
        ...prev,
        account_number: "Duplicate account number in list",
      }));
      return;
    }

    try {
      const resp = await post("/distributor/updateBank", {
        user_Id: userId,
        distributor_id,
        bank_details: {
          bank_id: editingBankId,
          bank_name: form.bank_name,
          account_holder_name: form.account_holder_name,
          account_number: form.account_number,
          ifsc_code: form.ifsc_code,
          bank_branch: form.bank_branch,
        },
      });
      if (resp.data.Success) {
        toast.success("Bank details updated successfully");
        await fetchBankDetails(distributor_id);
        setEditingBankId(null);
        setForm((prev) => ({
          ...prev,
          bank_name: "",
          account_holder_name: "",
          account_number: "",
          ifsc_code: "",
          bank_branch: "",
        }));
      } else {
        toast.error(resp.data.Message || "Update Bank failed");
      }
    } catch {
      toast.error("Error occurred while updating bank details");
    }
  };

  const handleDeleteBank = async (bankId) => {
    if (!window.confirm("Are you sure you want to delete this bank account?")) return;
    try {
      const resp = await post("/distributor/deleteBank", {
        bank_id: bankId,
        user_Id: userId,
      });
      if (resp.data.Success) {
        toast.success("Bank details deleted successfully");
        await fetchBankDetails(distributor_id);
      } else {
        toast.error(resp.data.Message || "Delete failed");
      }
    } catch {
      toast.error("Error deleting bank details");
    }
  };

  // Fund Management
  const handleFundInputChange = (tableType, index, field, value) => {
    let updated;
    let setDataFn;

    if (tableType === "aifII") {
      updated = [...aifCatIIData];
      setDataFn = setAifCatIIData;
    } else if (tableType === "aifIII") {
      updated = [...aifCatIIIData];
      setDataFn = setAifCatIIIData;
    } else if (tableType === "pms") {
      updated = [...pmsData];
      setDataFn = setPmsData;
    } else {
      return;
    }

    updated[index][field] = value;

    if (tableType === "aifII") {
      const row = updated[index];
      const placement = parseFloat(row.placement_fee || 0);
      const upfront = parseFloat(row.upfront_fee || 0);
      const trail = parseFloat(row.trail_fee || 0);

      if (!isNaN(placement) && !isNaN(upfront) && !isNaN(trail)) {
        row.total_fee = (placement + upfront + trail).toFixed(2);
      }
    }

    setDataFn(updated);
  };

  const handleAddFund = async () => {
    try {
      if (!fundType) {
        toast.error("Please select a Fund Type");
        return;
      }
      if (!selectedFundName) {
        toast.error("Please select a Fund Name");
        return;
      }
      if (!selectedClassCode) {
        toast.error("Please select a Class Code");
        return;
      }

      const selectedFund = fundNames.find((f) => f.fund_name === selectedFundName);

      if (!selectedFund) {
        toast.error("Please select a valid Fund Name before adding.");
        return;
      }

      // Get the selected class to get product_type_id
      const selectedClass = classCodes.find((c) => c.class_code === selectedClassCode);

      if (!selectedClass) {
        toast.error("Invalid class code selected.");
        return;
      }

      const num = (v) => {
        if (v === undefined || v === null) return null;
        const s = String(v).trim();
        if (s === "") return null;
        const n = parseFloat(s);
        return Number.isNaN(n) ? null : n;
      };

      const isValidPercentage = (v) => {
        if (v === undefined || v === null) return false;
        const n = parseFloat(String(v).trim());
        if (Number.isNaN(n)) return false;
        return n >= 0 && n <= 100;
      };

      let product_details = [];

      // Common fields for all product types
      const commonFields = {
        product_id: selectedClass.product_type_id || 1,
        product_type_id: selectedClass.product_type_id || 1,
        fund_id: selectedFund.fund_id,
        class_code: selectedClassCode,
        is_active: true,
      };

      if (fundTableType === "aifII") {
        const row = aifCatIIData[0];
        const placement = num(row.placement_fee);
        const upload = num(row.upfront_fee);
        const trail = num(row.trail_fee);
        const size = row.size;
        const managementFee = num(row.management_fee);

        if (placement === null || upload === null || trail === null) {
          throw new Error(
            `AIF CAT II - Class "${selectedClassCode}": Placement, Upfront and Trail fees are mandatory.`
          );
        }
        if (
          !isValidPercentage(placement) ||
          !isValidPercentage(upload) ||
          !isValidPercentage(trail)
        ) {
          throw new Error(
            `AIF CAT II - Class "${selectedClassCode}": Fees must be numeric percentages between 0 and 100.`
          );
        }

        product_details = [{
          ...commonFields,
          size: size,
          placement_fee_per: placement,
          upfront_fee_per: upload,
          trail_fee_per: trail,
          total_fee_per: row.total_fee,
          management_fee_sharing_per: managementFee,
          performance_fee_sharing_per: null,
        }];
      } else if (fundTableType === "aifIII") {
        const row = aifCatIIIData[0];
        const managementFee = num(row.management_fee);
        const performanceFee = num(row.performance_fee);

        product_details = [{
          ...commonFields,
          size: null,
          placement_fee_per: null,
          upfront_fee_per: null,
          trail_fee_per: null,
          total_fee_per: null,
          management_fee_sharing_per: managementFee,
          performance_fee_sharing_per: performanceFee,
        }];
      } else if (fundTableType === "pms") {
        const row = pmsData[0];
        const managementFee = num(row.management_fee);
        const distributorFee = num(row.distributor_sharing_fee);

        product_details = [{
          ...commonFields,
          size: null,
          placement_fee_per: null,
          upfront_fee_per: null,
          trail_fee_per: null,
          total_fee_per: null,
          management_fee_sharing_per: managementFee,
          performance_fee_sharing_per: distributorFee,
        }];
      }

      if (product_details.length === 0) {
        toast.error("No rows to add. Ensure class and fees are entered.");
        return;
      }

      const payload = {
        distributor_id: distributor_id || 0,
        user_Id: userId,
        product_details: product_details,
      };

      const res = await post("/onboarding/saveDistributorProductDetails", payload);

      if (res?.data?.Success) {
        toast.success("Fund details added successfully!");

        const saved = Array.isArray(res.data.Data) && res.data.Data.length ? res.data.Data : product_details;

        setSavedFund((prev) => [
          ...prev,
          ...saved.map((r) => ({
            fund_name: selectedFundName,
            class: r.class_code ?? "",
            size: r.size ?? "",
            management_fee: r.management_fee_sharing_per ?? "",
            performance_fee: r.performance_fee_sharing_per ?? "",
            placement_fee: r.placement_fee_per ?? "",
            upfront_fee: r.upfront_fee_per ?? "",
            trail_fee: r.trail_fee_per ?? "",
            total_fee: r.total_fee_per ?? "",
            distributor_sharing_fee: r.performance_fee_sharing_per ?? "",
          })),
        ]);

        // Reset selections
        setSelectedFundName("");
        setSelectedClassCode("");
        setFundType("");
        setFundTableType("");

        // Reset form data
        setAifCatIIData([{
          fund_name: "", class: "", size: "", management_fee: "", placement_fee: "", upfront_fee: "", trail_fee: "", total_fee: ""
        }]);
        setAifCatIIIData([{ fund_name: "", class: "", management_fee: "", performance_fee: "" }]);
        setPmsData([{ fund_name: "", class: "", management_fee: "", distributor_sharing_fee: "" }]);

      } else {
        toast.error(res?.data?.Message || "Failed to save fund details.");
      }
    } catch (err) {
      console.error("Error saving fund details:", err);
      toast.error(err?.message || "An error occurred while saving.");
    }
  };

  const handleDeleteFund = (fundToDelete) => {
    setSavedFund(prev => prev.filter(fund =>
      !(fund.fund_name === fundToDelete.fund_name && fund.class === fundToDelete.class)
    ));
    toast.success("Fund removed successfully");
  };

  // Main Submit Handler - FIXED
  const handleSubmit = async (e) => {
    e.preventDefault();

    // For edit mode, always allow submission regardless of validation
    if (isEditMode) {
      // Just proceed with submission
      console.log("✅ Edit mode - proceeding with submission regardless of validation");
    } else {
      // For new mode, do validation
      if (!canSubmitForm()) {
        toast.error("Please fill all required fields correctly and ensure you have at least one SPOC, one Bank, and a primary SPOC.");
        return;
      }
    }

    // Format dates properly
    const formattedExpiryDate = form.arn_expiry_date
      ? moment(form.arn_expiry_date).format('YYYY-MM-DD')
      : null;

    const payload = {
      action: "submit",
      distributor_id: distributor_id || 0,
      distributor_name: form.distributor_name.toUpperCase(),
      arn_code: form.arn_code.toUpperCase(),
      arn_expiry_date: formattedExpiryDate,
      pan_number: form.pan_number.toUpperCase(),
      city: form.city.toUpperCase(),
      address: form.address.toUpperCase(),
      pincode: form.pin_code,
      authorized_signatory: form.authorized_signatory.toUpperCase(),
      is_arn_active: form.is_arn_active ?? true,
      is_active: true,

      spoc_details: spocList.map((spoc) => ({
        spoc_id: spoc.spoc_id || 0,
        spoc_name: spoc.spoc_name,
        email_1: spoc.spoc_email1,
        email_2: spoc.spoc_email2 || "",
        mobile_1: spoc.spoc_mobile1,
        mobile_2: spoc.spoc_mobile2 || "",
        is_primary: spoc.spoc_is_primary === "Yes",
        is_active: true
      })),

      bank_details: bankList.map((bank) => ({
        bank_id: bank.id || 0,
        bank_name: bank.bank_name,
        account_holder_name: bank.account_holder_name,
        account_number: bank.account_number,
        ifsc_code: bank.ifsc_code,
        bank_branch: bank.bank_branch,
        is_active: true
      })),

      product_details: savedFund.map((fund) => ({
        fund_name: fund.fund_name,
        class_code: fund.class,
        size: fund.size || null,
        placement_fee_per: fund.placement_fee || null,
        upfront_fee_per: fund.upfront_fee || null,
        trail_fee_per: fund.trail_fee || null,
        management_fee_sharing_per: fund.management_fee || null,
        performance_fee_sharing_per: fund.performance_fee || null,
      })),
    };

    console.log("📤 Submitting payload:", payload);

    try {
      setLoading(true);
      const resp = await post("/onboarding/saveDistributorMaster", payload);

      if (resp?.data?.Success) {
        toast.success(resp.data.Message || "Distributor submitted successfully!");

        // If this was a new distributor, update the ID
        if (!distributor_id && resp.data.Data) {
          setDistributorId(resp.data.Data);
        }

        // Call onBack callback if provided
        if (onBack) {
          onBack();
        }
      } else {
        toast.error(resp?.data?.Message || "Failed to submit distributor. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error submitting distributor:", error);
      toast.error("Failed to submit distributor. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setEditingSpocId(null);
    setEditingBankId(null);
    setForm((prev) => ({
      ...prev,
      spoc_name: "",
      spoc_email1: "",
      spoc_email2: "",
      spoc_mobile1: "",
      spoc_mobile2: "",
      spoc_is_primary: false,
      bank_name: "",
      account_holder_name: "",
      account_number: "",
      ifsc_code: "",
      bank_branch: "",
    }));
  };

  // Table Columns
  const spocColumns = [
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              setEditingSpocId(row.original.spoc_id);
              setForm((prev) => ({
                ...prev,
                spoc_name: row.original.spoc_name,
                spoc_email1: row.original.spoc_email1,
                spoc_email2: row.original.spoc_email2 || "",
                spoc_mobile1: row.original.spoc_mobile1,
                spoc_mobile2: row.original.spoc_mobile2 || "",
                spoc_is_primary: row.original.spoc_is_primary === "Yes",
              }));
            }}
            className="text-indigo-400 hover:text-indigo-600 hover:bg-indigo-50 p-2 rounded-lg transition-all"
          >
            <SquarePen size={18} />
          </button>
          <button
            onClick={() => handleDeleteSPOC(row.original.spoc_id)}
            className="text-red-400 hover:text-red-600 hover:bg-red-50 p-2 rounded-lg transition-all"
          >
            <Trash2 size={18} />
          </button>
        </div>
      ),
      disableSortBy: true,
      size: 100,
    },
    {
      Header: "SPOC Name",
      accessor: "spoc_name",
      size: 150,
      Cell: ({ value }) => <span className="font-bold text-gray-900 uppercase">{value}</span>
    },
    {
      Header: "Contact Info",
      accessor: "spoc_email1",
      size: 250,
      Cell: ({ row }) => (
        <div className="flex flex-col">
          <span className="text-xs font-medium text-gray-800 lowercase italic">{row.original.spoc_email1}</span>
          <span className="text-[11px] text-gray-500 font-bold">{row.original.spoc_mobile1}</span>
        </div>
      )
    },
    {
      Header: "Is Primary",
      accessor: "spoc_is_primary",
      size: 100,
      Cell: ({ value }) => {
        const isPrimary = value === "Yes";
        return (
          <div className={`flex items-center gap-2 px-3 py-1 rounded-full border ${isPrimary ? "bg-[#EBFFF3] text-[#10B981]" : "bg-[#F3F4F6] text-[#6B7280]"} text-[11px] font-bold w-fit`}>
            <span className={`w-1.5 h-1.5 rounded-full ${isPrimary ? "bg-[#10B981]" : "bg-[#9CA3AF]"}`} />
            {isPrimary ? "Primary" : "Secondary"}
          </div>
        );
      }
    },
  ];

  const bankColumns = [
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              setEditingBankId(row.original.id);
              setForm((prev) => ({
                ...prev,
                bank_name: row.original.bank_name,
                account_holder_name: row.original.account_holder_name,
                account_number: row.original.account_number,
                ifsc_code: row.original.ifsc_code,
                bank_branch: row.original.bank_branch,
              }));
            }}
            className="text-indigo-400 hover:text-indigo-600 hover:bg-indigo-50 p-2 rounded-lg transition-all"
          >
            <SquarePen size={18} />
          </button>
          <button
            onClick={() => handleDeleteBank(row.original.id)}
            className="text-red-400 hover:text-red-600 hover:bg-red-50 p-2 rounded-lg transition-all"
          >
            <Trash2 size={18} />
          </button>
        </div>
      ),
      disableSortBy: true,
      size: 100,
    },
    { Header: "Bank Name", accessor: "bank_name", size: 150 },
    { Header: "A/C Holder", accessor: "account_holder_name", size: 150 },
    { Header: "A/C Number", accessor: "account_number", size: 150 },
    { Header: "IFSC", accessor: "ifsc_code", size: 120 },
  ];

  const fundColumns = [
    {
      Header: "Fund Name",
      accessor: "fund_name",
      size: 150,
      Cell: ({ value }) => <div className="px-2 py-1 font-bold text-gray-900 line-clamp-1">{value || "N/A"}</div>,
    },
    {
      Header: "Class",
      accessor: "class",
      size: 100,
      Cell: ({ value }) => <div className="px-2 py-1 text-xs font-bold text-indigo-600">{value || "N/A"}</div>,
    },
    {
      Header: "Management Fee (%)",
      accessor: "management_fee",
      size: 150,
      Cell: ({ value }) => <div className="px-2 py-1 text-sm font-medium">{value ? `${value}%` : "0%"}</div>,
    },
    {
      Header: "Action",
      accessor: "action",
      size: 80,
      Cell: ({ row }) => (
        <button
          onClick={() => handleDeleteFund(row.original)}
          className="text-red-400 hover:text-red-600 hover:bg-red-50 p-2 rounded-lg transition-all"
        >
          <Trash2 size={18} />
        </button>
      ),
    },
  ];

  // Input render helper with error handling
  const renderInput = (field, label, placeholder, type = "text", className = "", cols = "col-span-1") => (
    <div className={`${cols} ${className}`}>
      <label className="block text-[#4B5563] text-[13px] font-semibold mb-1.5">
        {label}
        {(field === "distributor_name" ||
          field === "pan_number" ||
          field === "pin_code" ||
          field === "city" ||
          field === "address" ||
          field === "authorized_signatory") && (
            <span className="text-red-600"> *</span>
          )}
      </label>
      <input
        value={form[field] || ""}
        onChange={(e) => handleChange(field, e.target.value)}
        placeholder={placeholder}
        type={type}
        className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] transition-all ${errors[field] ? "border-red-500 ring-1 ring-red-100" : ""}`}
      />
      {errors[field] && (
        <p className="text-red-500 text-[11px] mt-1 font-medium">{errors[field]}</p>
      )}
    </div>
  );

  const InputField = ({ label, value, onChange, className = "", readOnly = false }) => (
    <div className="flex flex-col">
      <label className="text-[#4B5563] text-[13px] font-semibold mb-1.5">{label}</label>
      <input
        type="text"
        inputMode="decimal"
        value={value ?? ""}
        onChange={onChange}
        readOnly={readOnly}
        className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] transition-all ${readOnly ? "bg-gray-50 cursor-not-allowed text-gray-500 font-bold" : ""} ${className}`}
      />
    </div>
  );

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Distributor Details */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
            <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 bg-indigo-500 rounded-full" />
              Distributor Details
            </h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {renderInput("distributor_name", "Distributor Name", "Enter name")}
              {renderInput("arn_code", "APRN Code", "Enter APRN code")}

              {/* APRN Expiry Date */}
              <div className="relative">
                <label className="block text-[#4B5563] text-[13px] font-semibold mb-1.5">
                  APRN Expiry Date
                  {form.arn_code && <span className="text-red-600"> *</span>}
                </label>
                <div className="relative">
                  <input
                    ref={inputRef}
                    value={
                      form.arn_expiry_date && moment(form.arn_expiry_date).isValid()
                        ? moment(form.arn_expiry_date).format("DD-MM-YYYY")
                        : ""
                    }
                    onFocus={() => setShowCalendar(true)}
                    readOnly
                    placeholder="Select date"
                    className={`w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] cursor-pointer transition-all ${errors.arn_expiry_date ? "border-red-500 ring-1 ring-red-100" : ""
                      }`}
                  />
                  {showCalendar && (
                    <div
                      ref={calendarRef}
                      className="absolute z-20 bg-white shadow-2xl mt-2 rounded-xl border border-gray-100 overflow-hidden"
                    >
                      <Calendar
                        value={form.arn_expiry_date && moment(form.arn_expiry_date).isValid()
                          ? form.arn_expiry_date
                          : new Date()}
                        minDate={new Date()}
                        onChange={(date) => {
                          handleChange("arn_expiry_date", date);
                          setShowCalendar(false);

                          const expired = new Date(date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
                          if (expired) {
                            toast.warn("APRN Expiry is in the past. Distributor will be marked inactive.");
                            setForm(prev => ({ ...prev, is_arn_active: false }));
                          } else {
                            setForm(prev => ({ ...prev, is_arn_active: true }));
                          }
                        }}
                      />
                    </div>
                  )}
                </div>
                {errors.arn_expiry_date && (
                  <p className="text-red-500 text-[11px] mt-1 font-medium italic">
                    {errors.arn_expiry_date}
                  </p>
                )}
              </div>

              {renderInput("pan_number", "PAN Number", "Enter PAN")}
              {renderInput("pin_code", "Pin Code", "Enter pin")}
              {renderInput("city", "City", "Enter city")}
              {renderInput("address", "Address", "Enter address", "text", "", "md:col-span-2")}

              <div className="flex flex-col justify-end pb-1.5">
                <label className="inline-flex items-center cursor-pointer gap-3">
                  <div className="relative">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={form.is_arn_active}
                      onChange={(e) => handleChange("is_arn_active", e.target.checked)}
                      disabled={isArnExpired()}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                  </div>
                  <span className="text-sm font-semibold text-gray-700">
                    Is APRN Active
                    {isArnExpired() && (
                      <span className="text-red-500 ml-2 italic text-xs">(Expired)</span>
                    )}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* SPOC Details */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50 flex justify-between items-center">
            <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 bg-indigo-500 rounded-full" />
              SPOC Details
            </h2>
            {!hasPrimarySpoc() && (
              <span className="text-[11px] font-bold text-amber-600 bg-amber-50 px-3 py-1 rounded-full border border-amber-100 flex items-center gap-1">
                ⚠️ Primary SPOC Required
              </span>
            )}
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-6 gap-6 mb-8">
              {renderInput("spoc_name", "SPOC Name", "Enter SPOC", "text", "", "md:col-span-2")}
              {renderInput("spoc_email1", "Email 1", "Enter email", "email", "", "md:col-span-2")}
              {renderInput("spoc_email2", "Email 2", "Enter email", "email", "", "md:col-span-2")}
              {renderInput("spoc_mobile1", "Mobile 1", "Enter mobile", "tel", "", "md:col-span-2")}
              {renderInput("spoc_mobile2", "Mobile 2", "Enter mobile", "tel", "", "md:col-span-2")}

              <div className="md:col-span-2 flex flex-col justify-end pb-1.5">
                <label className="inline-flex items-center cursor-pointer gap-3">
                  <div className="relative">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={form.spoc_is_primary}
                      onChange={(e) => handleChange("spoc_is_primary", e.target.checked)}
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                  </div>
                  <span className="text-sm font-semibold text-gray-700">
                    Is Primary <span className="text-red-500">*</span>
                  </span>
                </label>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={editingSpocId ? handleUpdateSpoc : handleAddSpoc}
                disabled={!form.spoc_name?.trim() || !form.spoc_email1?.trim() || !form.spoc_mobile1?.trim()}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold transition-all shadow-sm ${!form.spoc_name?.trim() ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border border-indigo-200"
                  }`}
              >
                {editingSpocId ? <SquarePen className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                {editingSpocId ? "Update SPOC" : "Add SPOC Details"}
              </button>

              {(editingSpocId || editingBankId) && (
                <button
                  type="button"
                  onClick={handleCancelEdit}
                  className="px-6 py-2.5 bg-gray-50 text-gray-600 hover:bg-gray-100 rounded-lg text-sm font-bold border border-gray-200 transition-all"
                >
                  Cancel Edit
                </button>
              )}
            </div>

            <div className="mt-8 bg-gray-50/50 rounded-xl border border-gray-100 overflow-hidden">
              <ReusableTable columns={spocColumns} data={spocList} />
            </div>
          </div>
        </div>

        {/* Bank Details */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden mt-6">
          <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
            <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 bg-indigo-500 rounded-full" />
              Bank Details
            </h2>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              {renderInput("bank_name", "Bank Name", "Enter bank")}
              {renderInput("account_holder_name", "Account Holder Name", "Enter holder name")}
              {renderInput("account_number", "Account Number", "Enter number")}
              {renderInput("ifsc_code", "IFSC Code", "Enter IFSC")}
              {renderInput("bank_branch", "Bank Branch", "Enter branch")}
            </div>

            <div className="flex items-center">
              <button
                type="button"
                onClick={editingBankId ? handleUpdateBank : handleAddBank}
                disabled={!form.bank_name?.trim() || !form.account_number?.trim() || !form.ifsc_code?.trim()}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold transition-all shadow-sm ${!form.bank_name?.trim() ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border border-indigo-200"
                  }`}
              >
                {editingBankId ? <SquarePen className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                {editingBankId ? "Update Bank" : "Add Bank Account"}
              </button>
            </div>

            <div className="mt-8 bg-gray-50/50 rounded-xl border border-gray-100 overflow-hidden">
              <ReusableTable columns={bankColumns} data={bankList} />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden mt-6">
          <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50">
            <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 bg-indigo-500 rounded-full" />
              Authorized Signatory
            </h2>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {renderInput("authorized_signatory", "Authorized Signatory", "Enter name", "text", "", "md:col-span-2")}
            </div>
          </div>
        </div>

        {/* Fund Details */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden mt-6">
          <div className="px-6 py-4 border-b border-gray-50 bg-gray-50/50 flex justify-between items-center">
            <h2 className="text-sm font-bold text-gray-900 uppercase tracking-wider flex items-center gap-2">
              <span className="w-1 h-4 bg-indigo-500 rounded-full" />
              Fund Details
            </h2>
          </div>

          <div className="p-6 space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Fund Type Selector */}
              <div className="flex flex-col">
                <label className="block text-[#4B5563] text-[13px] font-semibold mb-1.5">Fund Type</label>
                <select
                  value={fundType}
                  onChange={(e) => {
                    setFundType(e.target.value);
                    setSelectedFundName("");
                    setClassCodes([]);
                    setSelectedClassCode("");
                    setFundTableType("");
                  }}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] transition-all"
                >
                  <option value="">Select Fund Type</option>
                  <option value="aif">AIF</option>
                  <option value="pms">PMS</option>
                </select>
              </div>

              <div className="flex flex-col">
                <label className="block text-[#4B5563] text-[13px] font-semibold mb-1.5">Fund Name</label>
                <select
                  value={selectedFundName}
                  onChange={(e) => setSelectedFundName(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] transition-all disabled:bg-gray-50 disabled:cursor-not-allowed"
                  disabled={!fundNames.length}
                >
                  <option value="">Select Fund Name</option>
                  {fundNames.map((fund) => (
                    <option key={fund.fund_id} value={fund.fund_name}>
                      {fund.fund_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex flex-col">
                <label className="block text-[#4B5563] text-[13px] font-semibold mb-1.5">Class Code</label>
                <select
                  value={selectedClassCode}
                  onChange={(e) => setSelectedClassCode(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 focus:outline-none focus:ring-1 focus:ring-indigo-500 bg-white h-[42px] transition-all disabled:bg-gray-50 disabled:cursor-not-allowed"
                  disabled={!classCodes.length}
                >
                  <option value="">Select Class Code</option>
                  {classCodes.map((cls) => (
                    <option key={cls.class_code} value={cls.class_code}>
                      {cls.class_code}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Fund Input Forms */}
            {fundTableType === "aifII" && (
              <div className="bg-gray-50/50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">AIF CAT II Fees Configuration</h3>
                {aifCatIIData.map((row, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <InputField label="Size" value={row.size} onChange={(e) => handleFundInputChange("aifII", index, "size", e.target.value)} />
                    <InputField label="Mgmt Fee %" value={row.management_fee} onChange={(e) => handleFundInputChange("aifII", index, "management_fee", e.target.value)} />
                    <InputField label="Placement Fee %" value={row.placement_fee} onChange={(e) => handleFundInputChange("aifII", index, "placement_fee", e.target.value)} />
                    <InputField label="Upfront Fee %" value={row.upfront_fee} onChange={(e) => handleFundInputChange("aifII", index, "upfront_fee", e.target.value)} />
                    <InputField label="Trail Fee %" value={row.trail_fee} onChange={(e) => handleFundInputChange("aifII", index, "trail_fee", e.target.value)} />
                    <InputField label="Total Fee %" value={row.total_fee} readOnly />
                  </div>
                ))}
              </div>
            )}

            {fundTableType === "aifIII" && (
              <div className="bg-gray-50/50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">AIF CAT III Fees Configuration</h3>
                {aifCatIIIData.map((row, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Management Fee %" value={row.management_fee} onChange={(e) => handleFundInputChange("aifIII", index, "management_fee", e.target.value)} />
                    <InputField label="Performance Fee %" value={row.performance_fee} onChange={(e) => handleFundInputChange("aifIII", index, "performance_fee", e.target.value)} />
                  </div>
                ))}
              </div>
            )}

            {fundTableType === "pms" && (
              <div className="bg-gray-50/50 p-6 rounded-xl border border-gray-100">
                <h3 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">PMS Fees Configuration</h3>
                {pmsData.map((row, index) => (
                  <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Management Fee %" value={row.management_fee} onChange={(e) => handleFundInputChange("pms", index, "management_fee", e.target.value)} />
                    <InputField label="Distributor Sharing Fee %" value={row.distributor_sharing_fee} onChange={(e) => handleFundInputChange("pms", index, "distributor_sharing_fee", e.target.value)} />
                  </div>
                ))}
              </div>
            )}

            {fundTableType && (
              <div className="flex justify-start">
                <button
                  type="button"
                  onClick={handleAddFund}
                  disabled={!selectedFundName || !selectedClassCode}
                  className="flex items-center gap-2 px-6 py-2.5 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border border-indigo-200 rounded-lg text-sm font-bold transition-all shadow-sm"
                >
                  <Plus className="w-4 h-4" />
                  Add/Update Fund Fees
                </button>
              </div>
            )}

            {/* Saved Funds Table */}
            {savedFund.length > 0 && (
              <div className="pt-6 border-t border-gray-100">
                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 flex items-center gap-2">
                  <Check className="w-3 h-3" />
                  Successfully Added Funds
                </h3>
                <div className="bg-gray-50/50 rounded-xl border border-gray-100 overflow-hidden">
                  <ReusableTable columns={fundColumns} data={savedFund} />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex justify-end items-center gap-4 pt-10 pb-20 border-t border-gray-100 mt-10">
          <button
            type="button"
            onClick={onBack}
            className="flex items-center gap-2 px-8 py-3 bg-white hover:bg-gray-50 text-gray-700 font-bold rounded-xl transition-all border border-gray-200 shadow-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
          <button
            type="submit"
            disabled={loading}
            className={`flex items-center gap-2 px-10 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl transition-all shadow-lg shadow-indigo-100 ${loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <Save className="w-4 h-4" />
            )}
            {isEditMode ? "Update Distributor" : "Save Distributor"}
          </button>
        </div>
      </form>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AddDistributorForm;